( function () {
	'use strict';

	/* @ngInject */
	function apiResponses () {
		var defaultMsgs = {
			'-1' : {
				'title'   : '',
				'message' : 'Request aborted.'
			},

			'0' : {
				'title'   : 'Request cancelled.',
				'message' : 'Please check your connectivity and try again.'
			},

			'400' : {
				'title'   : 'Authentication error.',
				'message' : 'Please try again.'
			},
			'401' : {
				'title'   : 'Request unauthorized.',
				'message' : 'Please try again.'
			},
			'403' : {
				'title'   : 'Forbidden request.',
				'message' : 'Please try again.'
			},
			'404' : {
				'title'   : 'Page not found.',
				'message' : ''
			},
			'406' : {
				'title'   : 'Request not acceptable.',
				'message' : 'Please try again later.'
			},
			'410' : {
				'title'   : '',
				'message' : 'This module will soon stop functioning. Please use the new version.'
			},
			'420' : {
				'title'   : 'Rate limit exceeded.',
				'message' : 'Please try again later.'
			},
			'422' : {
				'title'   : 'Unprocessable Entity.',
				'message' : 'Please try again later.'
			},
			'429' : {
				'title'   : 'Too many request.',
				'message' : 'Please try again.'
			},
			'500' : {
				'title'   : 'Server error!',
				'message' : 'Please try again later.'
			},
			'502' : {
				'title'   : 'Bad gateway.',
				'message' : 'Please try again later.'
			},
			'503' : {
				'title'   : 'Service unavailable.',
				'message' : 'Please try again.'
			},
			'504' : {
				'title'   : 'Gateway timeout.',
				'message' : 'Please try again later.'
			}
		};

		return function ( statusCode, overrideMsg ) {
			return overrideMsg || defaultMsgs[ statusCode ];
		};
	}

	angular
		.module( 'app.components' )
		.factory( 'apiResponses', apiResponses );
} )( );
